import { Flex } from '@mantine/core';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { AuditTct } from '@dealstack/shared/lib/generated';
import { StyledSidebar } from '@dealstack/frontend/shared/components/Audit/AuditLayout/styled.ts';
import { AuditsList } from '@dealstack/frontend/shared/components/Audit/AuditLayout/AuditList.tsx';

interface Props {
	className?: string;
	audits: AuditTct[];
	isLoading: boolean;
	selectedAuditId: string | null;
	setSelectedAuditId: (id: string) => void;
}

export const AuditSidebar = ({
	className,
	audits,
	isLoading,
	selectedAuditId,
	setSelectedAuditId,
}: Props) => {
	return (
		<StyledSidebar className={className}>
			<Flex direction="column" gap="1rem" h="100%">
				{isLoading && !audits?.length && <InlineLoader />}

				{!isLoading && (
					<AuditsList
						audits={audits || []}
						selectedAuditId={selectedAuditId}
						setSelectedAuditId={setSelectedAuditId}
					/>
				)}
			</Flex>
		</StyledSidebar>
	);
};
